import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';

// The collapsed state of a sidebar (locations, issue list, work-tasks
// sidebar) used to be a bare ~25px sliver with a small icon button and no
// other affordance -- easy to miss entirely, which read as "the panel is
// gone" / "I can't select anything" rather than "click here to expand"
// (reported 2026-07-12). Now a wider, hoverable rail with a vertical label
// makes clear there's a whole panel tucked behind it.
const CollapsedRail: React.FC<{ label: string; onExpand: () => void }> = ({ label, onExpand }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Tooltip title={`Show ${label.toLowerCase()}`} placement="right">
      <div
        role="button"
        tabIndex={0}
        aria-label={`Show ${label.toLowerCase()}`}
        onClick={onExpand}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onExpand();
          }
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          background: hovered ? '#f0f5ff' : '#fafafa',
          borderRight: '1px solid #f0f0f0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 32,
          paddingTop: 10,
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
      >
        <RightOutlined style={{ fontSize: 11, color: hovered ? '#1677ff' : '#8c8c8c' }} />
        <div
          style={{
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)',
            marginTop: 10,
            fontSize: 11,
            color: hovered ? '#1677ff' : '#8c8c8c',
            letterSpacing: 1,
            userSelect: 'none',
          }}
        >
          {label}
        </div>
      </div>
    </Tooltip>
  );
};

export default CollapsedRail;
